module.exports = __webpack_public_path__ + "img/tree-05-g-leaves.69b017d5.png";